import React, { FC } from 'react'

import { Text } from '@interco/inter-ui/components/Text'

import { NoAvailableReportsContainer } from './styles'

type NoAvailableReportsProps = {
  description: string
}

export const NoAvailableReports: FC<NoAvailableReportsProps> = ({ description }) => (
  <NoAvailableReportsContainer>
    <Text variant="body-3" color="typography">
      {description}
    </Text>
  </NoAvailableReportsContainer>
)
